'use client';
import { jsx } from '@emotion/react/jsx-runtime';
import { forwardRef } from 'react';
import { createPolymorphicComponent } from '@s7/base';
import { Stack } from '@s7/layout';
import { rem } from '@s7/styles';
import { MediaQueryProvider } from './Footer.context.js';
import { FooterContainer } from './FooterContainer.js';
import { LinkOverrideProvider } from '../common/ResourceLink/LinkOverride.context.js';
import { unpackLink } from '../common/ResourceLink/ResourceLink.js';

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var desktopSpacing = rem(44);
var mobileSpacing = rem(32);
var _Footer = /*#__PURE__*/ forwardRef(function(props, ref) {
    var children = props.children, _props_linkMapper = props.linkMapper, linkMapper = _props_linkMapper === void 0 ? unpackLink : _props_linkMapper, others = _object_without_properties_loose(props, [
        "children",
        "linkMapper"
    ]);
    return /*#__PURE__*/ jsx(MediaQueryProvider, {
        query: [
            "md1.up",
            "[sm1,md1]"
        ],
        children: /*#__PURE__*/ jsx(LinkOverrideProvider, {
            linkMapper: linkMapper,
            children: /*#__PURE__*/ jsx(FooterContainer, _extends({
                ref: ref
            }, others, {
                children: /*#__PURE__*/ jsx(Stack, {
                    breakpoints: {
                        "md1.up": {
                            spacing: desktopSpacing
                        }
                    },
                    spacing: mobileSpacing,
                    children: children
                })
            }))
        })
    });
});
var Footer = createPolymorphicComponent(_Footer);

export { Footer, Footer as default };
